<template>
  <div>{{ humanReadable }}</div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  rule: {
    type: String,
    default: ''
  }
})

// Helper to prettify underscore strings and capitalize first letter
function prettifyText(text) {
  if (!text) return ''
  const spaced = text.replace(/_/g, ' ').trim()
  return spaced.charAt(0).toUpperCase() + spaced.slice(1)
}

// Helper to get human-friendly operator text
function humanOperator(op) {
  switch (op) {
    case '=': return 'equal to'
    case '>': return 'greater than'
    case '<': return 'less than'
    case 'between': return 'between'
    default: return op || 'unknown operator'
  }
}

const humanReadable = computed(() => {
  if (!props.rule) return '-'

  try {
    const ruleObj = JSON.parse(props.rule)

    const target = ruleObj.target ? prettifyText(ruleObj.target) : 'Unknown target'
    const operator = humanOperator(ruleObj.rule)
    const action = ruleObj.action ? ruleObj.action.charAt(0).toUpperCase() + ruleObj.action.slice(1) : 'N/A'

    let valuePart = ''
    if (operator === 'between' && ruleObj.value?.from != null && ruleObj.value?.to != null) {
      valuePart = `${ruleObj.value.from} and ${ruleObj.value.to}`
      return `If the ${target} is between ${valuePart}, then take action: ${action}.`
    } else if (ruleObj.value?.value != null) {
      valuePart = `${ruleObj.value.value}`
      return `If the ${target} is ${operator} ${valuePart}, then take action: ${action}.`
    } else {
      return `If the ${target} has an unspecified value, then take action: ${action}.`
    }
  } catch (e) {
    return props.rule || '-'
  }
})
</script>